import { getFileUrl } from '@/clients/http'
import { ChevronDown, ChevronUp, Image as ImageIcon, Trash2 } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { CardHeader, CardTitle } from '@/components/ui/card'
import { AdvancedImage } from '@/components/ui'

interface VariantCardHeaderProps {
    index: number
    isOpen: boolean
    setIsOpen: (isOpen: boolean) => void
    onRemove: (index: number) => void
    displayName: string
    thumbnailUrl?: string
}

export const VariantCardHeader = ({
    index,
    isOpen,
    setIsOpen,
    onRemove,
    displayName,
    thumbnailUrl,
}: VariantCardHeaderProps) => {
    return (
        <CardHeader className="flex-row items-center justify-between gap-3 bg-subdued px-4 py-3">
            <div className="flex min-w-0 items-center gap-3">
                <div className="flex size-10 shrink-0 items-center justify-center overflow-hidden rounded-md border border-border bg-card">
                    {thumbnailUrl ? (
                        <AdvancedImage
                            src={getFileUrl(thumbnailUrl)}
                            alt="Variant"
                            className="size-full object-cover"
                        />
                    ) : (
                        <ImageIcon className="size-4 text-faint" />
                    )}
                </div>
                <CardTitle className="truncate text-sm font-semibold">
                    {displayName || `Variant ${index + 1}`}
                </CardTitle>
            </div>
            <div className="flex shrink-0 items-center gap-1">
                <Button
                    type="button"
                    variant="ghost"
                    size="icon"
                    aria-label={isOpen ? 'Collapse variant' : 'Expand variant'}
                    onClick={() => setIsOpen(!isOpen)}
                >
                    {isOpen ? <ChevronUp /> : <ChevronDown />}
                </Button>
                <Button
                    type="button"
                    variant="ghost"
                    size="icon"
                    aria-label="Remove variant"
                    onClick={() => onRemove(index)}
                >
                    <Trash2 className="text-error" />
                </Button>
            </div>
        </CardHeader>
    )
}
